<template>

	<div class="progress-bar-container" v-if="type === 'parentqs'">
		<div class="progress-bar parentqs" v-if="!data.isNull" :style="{'width' : `${progressWidth + data[value]} %`, 'min-width' : `${data[value]}`}">{{ label + ' / ' + data[value] }}</div>
		<div class="na-bar" v-else>N/A</div>
	</div>

	<div class="progress-bar-container" v-else-if="type === 'lettergrade'">
		<div class="progress-bar lettergrade" v-if="!data.isNull" :style="{'min-width': progressWidth + '%'}">{{ data[value] }}</div>
		<div class="na-bar lettergrade" v-else>N/A</div>
	</div>

	<div class="progress-bar-container" v-else-if="type === 'azmerit'">
		<div class="progress-bar azmerit" v-if="!data.isNull" :style="{'min-width': progressWidth + '%'}">{{ label + ' / ' + Math.round(data[value]) + '%' }}</div>
		<div class="na-bar" v-else>N/A</div>
	</div>

	<div class="progress-bar-container" v-else-if="type === 'sat'">
		<div class="progress-bar sat" v-if="!data.isNull" :style="{'width' : `${avg / 800 * 100}%`, 'min-width' : `${(avg / 800) * 100}%`}">{{ label + ' / ' + Math.round(avg) }}</div>
		<div class="na-bar" v-else>N/A</div>
	</div>

	<div class="progress-bar-container" v-else-if="type === 'act'">
		<div class="progress-bar act" v-if="!data.isNull" :style="{'width' : `${avg / 40 * 100}%`, 'min-width' : `${(avg / 40) * 100}%`}">{{ Math.round(avg) }} / 40</div>
		<div class="na-bar" v-else>N/A</div>
	</div>

</template>

<script>

	export default {
		props: ['label', 'value', 'type', 'data', 'avg'],
		data() {
			return {
				progressWidth: 1,
				interval: setInterval(this.animateBar, 15)
			}
		},
		methods: {
			animateBar() {
				if (this.type === 'act' || this.type === 'sat') {
					if (this.progressWidth >= this.data[this.value] || this.progressWidth >= 100) {
						clearInterval(this.interval)
					} else {
						this.progressWidth++
					}
				} else {
					if (this.progressWidth >= this.data[this.value] || this.progressWidth >= 100) {
						clearInterval(this.interval)
					} else {
						this.progressWidth++
					}
				}
			}
		}
	}

</script>

<style lang="scss" scoped>
	.progress-bar-container {
			display: flex;
			align-items: center;
			justify-content: space-between;
			background-color: #f2f2f2;
			margin: 20px 0;
			border-radius: 5px;
		.progress-bar {
			color: #fff;
			padding: 10px;
			text-align: right;
			border-radius: 5px;
			font-size: 1rem; //1.2
			&.parentqs {
				background-color: #126;
			}
			&.lettergrade {
				background-color: #47786d;
				text-align: center;
				font-size: 1.5rem; //1.75
				font-weight: 600;
			}
			&.azmerit {
				background-color: darkred;
			}
			&.sat {
				background-color: #9bce42;
			}
			&.act {
				background-color: gold;
        color: black;
			}
		}
		.na-bar {
			color: #000;
			padding: 10px;
			text-align: center;
			width: 100%;
			border-radius: 5px;
			font-size: 1rem;
			&.lettergrade {
				font-size: 1.5rem;
			}
		}
		.label {
			margin-right: 10px;
		}
	}
</style>
